import React, { useContext } from 'react'
import { Box } from '@mui/material'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import NorthEastIcon from '@mui/icons-material/NorthEast'

import LanguageContext from "../../../contexts/LanguageContext"
import { useTexte } from "../../../contexts/FormeAdresseContext"

/* ⛔ « POUR ALLER PLUS LOIN » (08/10/2026, maquette v3 validee par Nawal).
   Sur l'ecran de fin de module SANS competence affichee, sous les
   felicitations : les deux ressources de la carte « Ressources » du tableau
   de bord, memes adresses (Dashboard.js), ouvertes dans un nouvel onglet.
   Deux cartes blanches a fine bordure et ombre douce, comme les cartes de
   reponse ; l'une sous l'autre au telephone. */
export const RESSOURCES_FIN_DE_MODULE = [
  { cle: "dictionnaire", url: "https://www.risinguparis.com/soft-skills", Icone: MenuBookOutlinedIcon },
  { cle: "blog", url: "https://www.risinguparis.com/blog", Icone: ArticleOutlinedIcon },
]

const RessourcesFinDeModule = () => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const t = useTexte()
  const textes = languageValues?.formation?.ressourcesFinModule || {}
  return (
    <Box data-ressources-fin-module sx={{ width: "100%", maxWidth: "700px", marginTop: ["40px", "50px", "50px", "50px"] }}>
      <Box sx={{ color: "rgba(0,0,0,0.7)", fontSize: ["16px", "18px", "18px", "18px"], lineHeight: 1.45, marginBottom: "15px" }}>
        {t(textes.titre)}
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr", "1fr 1fr"], gap: ["10px", "15px", "15px", "15px"] }}>
        {RESSOURCES_FIN_DE_MODULE.map(({ cle, url, Icone }) => (
          <Box
            key={cle}
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-ressource={cle}
            sx={{
              display: "flex", alignItems: "center", gap: "15px",
              padding: ["14px 16px", "16px 18px", "16px 18px", "16px 18px"],
              background: "#FFFFFF", border: "1px solid #E6E6E7", boxShadow: "0 0 15px rgba(0,0,0,0.05)",
              color: "#0A0A0B", textDecoration: "none", textAlign: "left",
              "&:hover": { borderColor: "#0A0A0B" },
            }}
          >
            <Box sx={{ width: "44px", height: "44px", flexShrink: 0, background: "#FAF8F6", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icone sx={{ fontSize: "22px" }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Box sx={{ fontSize: "16px", lineHeight: 1.35 }}>{textes?.[cle]?.titre?.[actLanguage]}</Box>
              <Box sx={{ fontSize: "14px", lineHeight: 1.4, color: "rgba(0,0,0,0.7)", marginTop: "3px" }}>{textes?.[cle]?.sous?.[actLanguage]}</Box>
            </Box>
            <NorthEastIcon sx={{ marginLeft: "auto", fontSize: "18px", color: "rgba(0,0,0,0.7)", flexShrink: 0 }} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default RessourcesFinDeModule
